import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/body-editor"
    exact
    path="/consumer/features/body-editor"
    component={AsyncPage}
  />,
];
